/*
 * @version: V1.0.0
 * @Date: 2023-11-02 18:00:37
 * @LastEditors: lzq
 * @LastEditTime: 2023-12-26 19:45:49
 * @company: 睿展数据
 * @FilePath: \udi-wms-client\src\api\upPackingRecords\index.js
 * @Descripttion:
 */
import request from '@/utils/request'

// 查询拆箱记录列表
export function getUppackingRecordsList(params) {
  return request({
    url: '/wms/unpacking/listProduct',
    method: 'get',
    params
  })
}


// 查询拆箱udi详情
export function getUppackingRecordsDetail(params) {
  return request({
    url: '/wms/unpackingProduct/list',
    method: 'get',
    params
  })
}

